import * as React from 'react'
import { Spinner } from './Spinner'
import { styled } from '../theme'

export const renderLoading = () => {
  return <Spinner />
}
export const renderCenteredLoading = () => {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  text-align: center;
  min-height: 150px;
  display: flex;

  align-items: center;
  justify-content: center;
`
